import styled from 'styled-components';
import { LinkButton } from '../../../../components/Toolkit/Button/LinkButton';

export const ShowMoreButton = styled(LinkButton)`
  margin-top: ${({ theme }) => theme.spacing.S12};
`;
